import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Box, CircularProgress } from "@mui/material";

export default function RoleGuard({ children, allowedRoles }) {
  const { profile, loading } = useAuth();

  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );

  const hasRole = allowedRoles.includes(profile?.role);

  // Check if profile is approved
  const isApproved = profile?.status === "approved";

  if (!hasRole || !isApproved) {
    // If not approved to see page, redirect to dashboard/waiting room
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
